import React from "react";
import { useTranslation } from "react-i18next";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import CarrierLogo from "../CarrierLogo";
import CarrierToggle from "../CarrierToggle";
import ServiceChecklist from "./ServiceChecklist";
import {
  carrierLogo,
  carrierName,
  carrierStatusText,
  isCarrierOn,
  serviceEntries,
  servicesOnCount,
} from "../../carrierHelpers";

// Also used for connected accounts, which add a subtitle (the account name) and actions.
const CarrierCard = ({
  row,
  expanded,
  onExpand,
  busy,
  onToggle,
  onServicesChange,
  subtitle,
  toggleLabel,
  actions,
}) => {
  const { t } = useTranslation("settings");
  const name = carrierName(row);
  const on = isCarrierOn(row);
  const total = serviceEntries(row).length;
  const ExpandIcon = expanded ? MdExpandLess : MdExpandMore;

  return (
    <div className="flex flex-col rounded-xl border border-ui-border bg-ui-surface transition-shadow hover:border-ui-border-strong hover:shadow-soft">
      <div className="flex items-start gap-3 pb-2.5 pl-3.5 pr-2 pt-3.5">
        <CarrierLogo src={carrierLogo(row)} name={name} dimmed={!on} />
        <div className="min-w-0 flex-1 self-center">
          <div className="text-[15px] font-semibold leading-snug text-ui-text">{name}</div>
          {subtitle && (
            <div className="truncate text-xs leading-snug text-ui-text-muted">{subtitle}</div>
          )}
        </div>
        <div className="-mt-1">
          <CarrierToggle
            checked={on}
            onChange={onToggle}
            disabled={busy}
            label={toggleLabel ?? t("carriers.showInQuotes", { name })}
          />
        </div>
      </div>
      <div className="mt-auto flex items-center justify-between gap-2 border-t border-ui-border-subtle px-3.5 py-[9px]">
        <span
          className={`text-xs font-medium ${on ? "text-ui-text-secondary" : "text-ui-text-subtle"}`}
        >
          {carrierStatusText(on, servicesOnCount(row), total)}
        </span>
        {total > 0 && (
          <button
            type="button"
            onClick={onExpand}
            aria-expanded={expanded}
            className="inline-flex items-center gap-1 rounded-full border border-ui-border bg-ui-surface px-2.5 py-1 text-xs font-medium text-brand transition-colors hover:border-brand hover:bg-brand-light"
          >
            {t("carriers.servicesButton")}
            <ExpandIcon className="h-4 w-4" />
          </button>
        )}
      </div>
      {actions && <div className="flex justify-end gap-1.5 px-3.5 pb-2.5">{actions}</div>}
      {expanded && total > 0 && (
        <div className="rounded-b-xl border-t border-ui-border-subtle bg-ui-surface-sunken px-3.5 pb-3.5 pt-2.5">
          <ServiceChecklist row={row} onChange={onServicesChange} disabled={busy} />
        </div>
      )}
    </div>
  );
};

export default CarrierCard;
